// extracted by mini-css-extract-plugin
export default {"container":"AF-z","header":"BF-z","details":"CF-z","link":"DF-z"};